export enum InvitesActionTypes {
  LOAD_INVITES_REQUEST = 'LOAD_INVITES_REQUEST',
  LOAD_INVITES_SUCCEEDED = 'LOAD_INVITES_SUCCEEDED',
  LOAD_INVITES_FAILED = 'LOAD_INVITES_FAILED',
  SEND_INVITES_REQUEST = 'SEND_INVITES_REQUEST',
  SEND_INVITES_SUCCEEDED = 'SEND_INVITES_SUCCEEDED',
  SEND_INVITES_FAILED = 'SEND_INVITES_FAILED',
  DELETE_INVITE_REQUEST = 'DELETE_INVITE_REQUEST',
  DELETE_INVITE_SUCCEEDED = 'DELETE_INVITE_SUCCEEDED',
  DELETE_INVITE_FAILED = 'DELETE_INVITE_FAILED',
}
